import { Ban } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/atoms/texts/label';
import { formatDate } from '@/utils/formatDate';

const OnboardingRefusedTag = ({ refusedAt, className = '' }) => {
    const [t] = useTranslation('global');
    const tooltip = refusedAt
        ? t('management.onboarding.refusal.refusedOn', { date: formatDate(new Date(refusedAt)) })
        : t('management.onboarding.refusal.refused');

    return (
        <span
            title={tooltip}
            className={['inline-flex items-center gap-1 h-5 px-2 rounded-full font-medium whitespace-nowrap bg-error20 text-error text-bodySmall', className].join(' ')}
        >
            <Ban className="h-3 w-3" />
            <Label size="small" color="error" message="management.onboarding.refusal.tag" />
        </span>
    );
};

export default OnboardingRefusedTag;
